/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_empty_cart_body = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Váš košík je prázdný.<br/>Kliknutím <a href="${i.link}">zde</a> pokračujte v nákupu.`
};

const da_empty_cart_body = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Din kurv er tom.<br/>Klik <a href="${i.link}">her</a> for at fortsætte med at handle.`
};

const de_empty_cart_body = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Ihr Warenkorb ist leer.<br/>Klicken Sie <a href="${i.link}">hier</a>, um weiter einzukaufen.`
};

const en_empty_cart_body = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `You have no items in your shopping cart.<br/>Click <a href="${i.link}">here</a> to continue shopping.`
};

const es_empty_cart_body = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Tu carrito está vacío.<br/>Haz clic <a href="${i.link}">aquí</a> para seguir comprando.`
};

const fr_empty_cart_body = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Votre panier est vide.<br/>Cliquez <a href="${i.link}">ici</a> pour continuer vos achats.`
};

const hu_empty_cart_body = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `A kosár üres.<br/>Kattints <a href="${i.link}">ide</a> a vásárlás folytatásához.`
};

const it_empty_cart_body = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Il tuo carrello è vuoto.<br/>Clicca <a href="${i.link}">qui</a> per continuare lo shopping.`
};

const nl_empty_cart_body = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Je winkelwagen is leeg.<br/>Klik <a href="${i.link}">hier</a> om verder te winkelen.`
};

const pl_empty_cart_body = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Twój koszyk jest pusty.<br/>Kliknij <a href="${i.link}">tutaj</a>, aby kontynuować zakupy.`
};

const pt_empty_cart_body = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Seu carrinho está vazio.<br/>Clique <a href="${i.link}">aqui</a> para continuar comprando.`
};

const sv_empty_cart_body = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Din kundvagn är tom.<br/>Klicka <a href="${i.link}">här</a> för att fortsätta handla.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ link: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const empty_cart_body = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.empty_cart_body(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("empty_cart_body", locale)
	if (locale === "cs") return cs_empty_cart_body(inputs)
	if (locale === "da") return da_empty_cart_body(inputs)
	if (locale === "de") return de_empty_cart_body(inputs)
	if (locale === "en") return en_empty_cart_body(inputs)
	if (locale === "es") return es_empty_cart_body(inputs)
	if (locale === "fr") return fr_empty_cart_body(inputs)
	if (locale === "hu") return hu_empty_cart_body(inputs)
	if (locale === "it") return it_empty_cart_body(inputs)
	if (locale === "nl") return nl_empty_cart_body(inputs)
	if (locale === "pl") return pl_empty_cart_body(inputs)
	if (locale === "pt") return pt_empty_cart_body(inputs)
	return sv_empty_cart_body(inputs)
};